import { bookingRefundOffers } from "../../../app/api/cancelBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { fulfillmentIdSet, isFulfilledStatus, isRefundableFulfillment } from "../../../Lib/Utils/refundableFulfillments";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookedOffer, IBookingResponse } from "../../../Orchestrator/Types/Index";
import { IBookingRefundOffersResponse, IRefundOfferRequest } from "../../../Orchestrator/Types/Types/BookingTypes";

class CancelBookingInitAction extends BaseAction<void, {
    booking: IBookingResponse,
    filteredOutboundData?: string[],
    filteredInboundData?: string[],
    outboundChecked?: boolean,
    inboundChecked?: boolean
}> {
    override async run(): Promise<void | null> {
        try {
            const { booking, filteredOutboundData, filteredInboundData, outboundChecked, inboundChecked } = this.params!;
            const passengerFulfillmentIds: string[] = [];
            let passengerIds: string[] = [];            
            
            if (filteredOutboundData && filteredOutboundData.length > 0) {
                if (booking?.booking?.passengers && booking?.booking?.passengers.length > 0) {
                    passengerIds = filteredOutboundData;
                }
            }
            else if (filteredInboundData && filteredInboundData.length > 0) {
                if (booking?.booking?.passengers && booking?.booking?.passengers.length > 0) {
                    passengerIds = filteredInboundData;
                }
            }
            else {
                if (booking?.booking?.passengers && booking?.booking?.passengers.length > 0) {
                    // Get all passenger IDs from tripData
                    passengerIds = booking.booking.passengers.map((passenger: any) => passenger.id);
                }
            }


            if (booking?.booking?.bookedOffers && booking?.booking?.fulfillments) {

                // Create a filtered copy of bookedOffers instead of modifying the original
                let filteredBookedOffers: IBookedOffer[] = [];

                if (outboundChecked) {
                    filteredBookedOffers.push(...booking.booking.bookedOffers.filter((offer: any) => {
                        const matchingTrip = booking.booking.trips.find((trip: any) =>
                            trip.id === offer.tripCoverage?.coveredTripId && trip.direction === "OUT_BOUND"
                        );
                        return matchingTrip !== undefined;
                    }));
                }
                if (inboundChecked) {
                    filteredBookedOffers.push(...booking.booking.bookedOffers.filter((offer: any) => {
                        const matchingTrip = booking.booking.trips.find((trip: any) =>
                            trip.id === offer.tripCoverage?.coveredTripId && trip.direction === "IN_BOUND"
                        );
                        return matchingTrip !== undefined;
                    }));
                }
                
                const fulfillmentIds = fulfillmentIdSet(booking?.booking);

                filteredBookedOffers.forEach((offer: IBookedOffer) => {
                    if (offer.admissions) {
                        offer.admissions.forEach((admission) => {
                            // Check if this admission contains any of our passengers
                            const hasMatchingPassenger = admission.passengerIds?.some((pid: string) =>
                                passengerIds.includes(pid)
                            );

                            // FULFILLED only. `!== "REFUNDED"` let RELEASED,
                            // EXCHANGED, CANCELLED and EXPIRED through, and the
                            // quote then priced ids the commit could not refund.
                            // Same predicate ConfirmCancelClickAction uses — the
                            // two paths disagreeing is what shipped the bug.
                            if (hasMatchingPassenger && isRefundableFulfillment(admission, fulfillmentIds)) {
                                passengerFulfillmentIds.push(admission.id);
                            }
                        });
                        /**
                         * Also need to refund ancillaries(addons) if any for passenger.
                         * No `booking.fulfillments` membership check here — an
                         * ancillary need not appear in that array (Nol never does)
                         * while the refund endpoints still accept its id.
                         */
                        const fulFilledAncillaries = (offer?.ancillaries || []).filter(
                            d => isFulfilledStatus(d) && passengerIds.includes(d.passengerIds?.[0])
                        )
                        if (fulFilledAncillaries.length > 0)
                            passengerFulfillmentIds.push(...fulFilledAncillaries.map(d => d.id))
                    }
                });

            }

            // Call RefundOffer API if we have fulfillment IDs
            if (passengerFulfillmentIds.length > 0) {
                const refundOfferRequest: IRefundOfferRequest = {
                    fulfillmentIds: passengerFulfillmentIds,
                    overruleCode: null,
                    refundDate: new Date().toISOString()
                };

                try {
                    const refundOfferResponse: any = await bookingRefundOffers(refundOfferRequest, booking?.booking?.id);

                    if (refundOfferResponse.status === 'ok' && refundOfferResponse.answer) {
                        const refundOfferData: IBookingRefundOffersResponse = refundOfferResponse.answer;

                        // Store refund offer data in recoil state for display on cancel page
                        updateRecoilState("refundOfferResponseAtom", refundOfferData);

                        // Extract and store specific refund information
                        if (refundOfferData.refundOffers && refundOfferData.refundOffers.length > 0) {
                            const firstRefundOffer = refundOfferData.refundOffers[0];
                            updateRecoilState("refundFeeAtom", firstRefundOffer.refundFee);
                            updateRecoilState("refundableAmountAtom", firstRefundOffer.refundableAmount);
                        }
                    }
                } catch (refundError) {
                    console.error("Error calling RefundOffer API:", refundError);
                }
            }

        } catch (error: any) {
            console.error("Error fetching userdetail:", error);
        }
    }
}

export const cancelBookingInitAction = new CancelBookingInitAction()


